import { jsx } from "react/jsx-runtime";
import { useTheme, Box } from "@mui/material";
import { chemistryOptions } from "../../constants.js";
import { ChemistryRating } from "../../types.js";
import { indicatorWrapper, dotWrapper, dotIndicator } from "./styles.js";
const ChemistryDot = ({ rating }) => {
  const theme = useTheme();
  const options = chemistryOptions(theme);
  const { color } = options.find((option) => option.value === rating) || {};
  if (!color || rating === ChemistryRating.NORMAL)
    return null;
  return /* @__PURE__ */ jsx(Box, { sx: indicatorWrapper, children: /* @__PURE__ */ jsx(Box, { sx: dotWrapper, children: /* @__PURE__ */ jsx(Box, { sx: dotIndicator(color) }) }) });
};
export {
  ChemistryDot
};
